/**
 * Basic modal behavior for Team Member info
 */
const TeamMemberModal = {
  _selectors: {
    modal: '.js-team-member-modal',
    modalContentHolder: '.js-team-member-item',
    modalContentTarget: '.js-modal-content-target',
    openTrigger: '.js-team-profile-show-modal-btn',
    closeTrigger: '.js-modal-team-member-close-btn'
  },

  init() {
    const self = this;

    this._createModalHtml();

    // Event - click on a member to open modal
    document.querySelectorAll(this._selectors.openTrigger).forEach(node => {
      node.addEventListener('click', self.openModal.bind(self));
    });

    // Event - closes modal
    document.addEventListener('click', e => {
      if (e.target.matches(self._selectors.closeTrigger)) {
        TeamMemberModal.closeModal();
      }
    });
  },

  openModal(e) {
    e.preventDefault();

    const teamMemberEl = e.currentTarget.closest(this._selectors.modalContentHolder);
    const decodedContent = JSON.parse( teamMemberEl.getAttribute('data-modal-content') );

    // Adds modal content and reveals it
    const modal = document.querySelector(this._selectors.modal);
    modal.querySelector(this._selectors.modalContentTarget).innerHTML = decodedContent;
    modal.classList.remove('hide');

    // Prevents page scroll
    document.querySelector('body').classList.add('no-scroll');

    // Hides nav menu
    if ( document.querySelector('.navbar') !== null ) {
      document.querySelector('.navbar').style.display = 'none';
    }
  },

  closeModal() {
    // Hides modal
    document.querySelector(this._selectors.modal).classList.add('hide');

    // Restores page scroll
    document.querySelector('body').classList.remove('no-scroll');

    // Shows nav menu
    if ( document.querySelector('.navbar') !== null ) {
      document.querySelector('.navbar').style.display = 'block';
    }
  },

  _createModalHtml() {
    const modalEl = document.createElement('div');
    modalEl.className = 'modal-window  allow-scroll  hide  modal-window--team-member  js-team-member-modal';

    const outerContainerEl = document.createElement('div');
    outerContainerEl.className = 'modal-window__container-outer';

    const innerContainerEl = document.createElement('div');
    innerContainerEl.className = 'modal-modal-window__container-inner  js-modal-content-target';

    outerContainerEl.appendChild(innerContainerEl);
    modalEl.appendChild(outerContainerEl);

    document.body.appendChild(modalEl);
  },
};

export default TeamMemberModal;
